export { MobileDetailModal } from "./MobileDetailModal";
